import { Component, forwardRef, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupplierClient, SupplierDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-supplier-control',
  templateUrl: './supplier-control.component.html',
  styleUrls: ['./supplier-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SupplierControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SupplierControlComponent),
      multi: true,
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupplierControlComponent extends BaseAutocompleteControl<SupplierDto> implements OnInit {

  @Input() type: number | null = 0;
  @Output() selectedSupplier: EventEmitter<SupplierDto> = new EventEmitter();

  constructor(private supplierClient: SupplierClient, private cache: AutocompleteCacheService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<SupplierDto[]> {
    const cacheKey = `suppliers_search_${searchValue}_type_${this.type}`;
    return this.cache.wrap(cacheKey, this.supplierClient.getSupplierByKeySearch(searchValue, this.type).pipe(
      map(items => items || [])
    ));
  }

  getDisplayValue(item: SupplierDto | null): string {
    return item?.name || '';
  }

  protected isValidItem(value: any): boolean {
    return value && typeof value === 'object' && ('id' in value || 'name' in value);
  }

  /**
   * Override to emit selectedSupplier event
   */
  protected outputValue(): void {
    super.outputValue();
    this.selectedSupplier.emit(this.selectedItem);
  }

  displayName = (item?: SupplierDto) => {
    return this.getDisplayValue(item || null);
  };
}
